import { FC } from 'react'

import { Button } from './common/Button'

import { appConfig } from '@/config'

type GetCurrencyButtonProps = {
  className?: string
  onClick?: () => void
}

export const GetCurrencyButton: FC<GetCurrencyButtonProps> = ({
  className = '',
  onClick,
}) => {
  return (
    <Button
      className={className}
      size="sm"
      variant="purpleAnimatedOutline"
      onClick={() => {
        window.open(appConfig.uniswapUrl)
        onClick?.()
      }}
    >
      GET {appConfig.currency}
    </Button>
  )
}
